import React, {useEffect, useContext, useState} from 'react';

import {
  Modal,
  Form,
  Dimmer,
  Loader,
  Dropdown,
  ModalHeader,
  ModalActions,
  Progress,
  Button,
  FormInput,
  TextArea,
} from 'semantic-ui-react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import ContactInput from '../../components/ContactInput';

import { toast } from 'react-toastify';

import {changeDeviceFriendlyName} from '../../../services/messageRecipients'
import RedirectContext from '../../../contexts/RedirectContext';


const ChangeContactModal = ({isModalOpen, close, residentId, endpointId}) => {

  const [makingCalls, setMakingCalls] = useState(false);
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const toggleRedirect = useContext(RedirectContext);



  const wait = async seconds => {
    return new Promise((resolve) => {
      setTimeout(resolve, seconds)
    })
  }


  const sendToast = (type = 'warn', message) => {
    if (type === 'success') {
        toast.success(message, {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });
    } else if (type === 'warn') {
        toast.warn(message, {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });
    }
};

  const navigate = (to: string) => {
    toggleRedirect(to);
    return;
};

  const submitContact = async () => {
    setMakingCalls(true);

    try {


      const result = await changeDeviceFriendlyName(residentId, endpointId, name);


      if (result) {
        // Good toast
        setMakingCalls(false);
        sendToast('success', 'Name change successful');
        close();
      } else {
        setMakingCalls(false);
        sendToast('warn', 'Failed to change the name');
        close();
      }
      setMakingCalls(false);

    } catch (err) {
      sendToast('warn', 'Failed to change the name');
      setMakingCalls(false);
      close();
    }
  }
  return (
    <Modal open={isModalOpen} onClose={()=> {if (!makingCalls) {close()}}} size={'tiny'} className="invite-modal-root" closeIcon>
      <ModalHeader>
        <h5>
          Enter new name for the device (This is what your contacts will see)
        </h5>
      </ModalHeader>

      <Form onSubmit={submitContact} error>
        <Modal.Content className="fnf-invite-modal-content">
          <Dimmer active={loading} inverted>
            <Loader active={loading} />
          </Dimmer>

          <div className="name-section">
            <FormInput
            
            value={name}
            onChange={(e) => {
                setName(e.target.value);
            }}
            required
            name="FirstName"
            placeholder="Friendly Name">

            </FormInput>
          </div>
          
        </Modal.Content>

        <ModalActions className="inviteBtn">
                    <Button className="ui primary small button " type="submit" loading={makingCalls}>
                        Save Name
                    </Button>
                </ModalActions>

      </Form>



    </Modal>






  )

}

export default ChangeContactModal